import React from 'react';

/**
 * Поля формы. Подпись — моноширинная микрометка из макета, контрол —
 * общий `.qp-control`, ошибка живёт под полем, а не в алерте наверху.
 */

interface FieldProps {
  label: string;
  required?: boolean;
  /** Пояснение под полем: что писать и чего не надо. */
  hint?: string;
  error?: string;
  /** Занять обе колонки сетки: описание, адрес, дропзона. */
  wide?: boolean;
  /** id контрола. Если задан — подпись становится настоящим `<label>`. */
  htmlFor?: string;
  children: React.ReactNode;
}

export function Field({ label, required, hint, error, wide, htmlFor, children }: FieldProps) {
  const classes = ['qp-field', wide ? 'qp-field--wide' : '', error ? 'qp-field--invalid' : '']
    .filter(Boolean)
    .join(' ');

  const caption = (
    <>
      {label}
      {required && (
        <span className="qp-field-req" aria-hidden>
          {' '}
          *
        </span>
      )}
    </>
  );

  return (
    <div className={classes}>
      {htmlFor ? (
        <label className="qp-field-label" htmlFor={htmlFor}>
          {caption}
        </label>
      ) : (
        <span className="qp-field-label">{caption}</span>
      )}
      {children}
      {error ? (
        <span className="qp-field-error" role="alert">
          {error}
        </span>
      ) : (
        hint && <span className="qp-field-hint">{hint}</span>
      )}
    </div>
  );
}

export function FieldGrid({ children }: { children: React.ReactNode }) {
  return <div className="qp-fields">{children}</div>;
}

/**
 * Значение, которое партнёр не редактирует сам: категория, координаты,
 * подтверждённый телефон. Пунктир и замок вместо пустой рамки — видно,
 * что поле не сломано, а закрыто.
 */
export function LockedValue({ children }: { children: React.ReactNode }) {
  return (
    <div className="qp-field-locked">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
        <rect x="5" y="11" width="14" height="9" rx="2" />
        <path d="M8 11V8a4 4 0 0 1 8 0v3" />
      </svg>
      <span>{children}</span>
    </div>
  );
}

interface SuffixedProps {
  /** Единица измерения внутри рамки: ₸, %, мин. */
  suffix: string;
  children: React.ReactNode;
}

export function Suffixed({ suffix, children }: SuffixedProps) {
  return (
    <div className="qp-field-suffixed">
      {children}
      <span className="qp-field-suffix" aria-hidden>
        {suffix}
      </span>
    </div>
  );
}
